import Vue from 'vue';
import VueMeta from 'vue-meta';
import App from './App.vue';
import router from './router';
import store from './store/store';
import './registerServiceWorker';

Vue.use(VueMeta);
Vue.config.productionTip = false;

const app = new Vue({
	router,
	store,
	render: (h) => h(App),
	mounted() {
		document.dispatchEvent(new Event('render-event'));
	},
});

router.onReady(() => {
	app.$mount('#app');
});
